import { useCallback, useRef, useState } from "react";
const scrollerTestId = "scroller";
const scrollerContentTestId = "scrollbar-content";
function useComputeOutOfViewportHeight() {
  const containerRef = useRef(null);
  const [outOfViewportHeight, setOutOfViewportHeight] = useState(0);
  const onSizeChange = useCallback((size) => {
    const container = containerRef.current;
    if (!container) return;
    const scroller = container.querySelector(`[data-testid="${scrollerTestId}"]`);
    const content = container.querySelector(`[data-testid="${scrollerContentTestId}"]`);
    if (!scroller || !content) {
      console.warn(
        '[useComputeOutOfViewportHeight] - cannot find any element with [data-testid="scroller"] or with [data-testid="scrollbar-content"]'
      );
      return;
    }
    setOutOfViewportHeight(content.offsetHeight - scroller.offsetHeight);
  }, []);
  return {
    containerRef,
    outOfViewportHeight,
    onSizeChange,
    scrollerContentTestId
  };
}
export {
  useComputeOutOfViewportHeight
};
//# sourceMappingURL=useComputeOutOfViewportHeight.js.map
